import React from "react";

// User-provided sage Heritage emblem
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_bloom-keeper-1/artifacts/lvqhl2r1_CroppedImage_20260512_130500.png";

/**
 * BrandLogo — the actual Heritage Dahlias sage emblem (user-supplied).
 * Use for splash/welcome/auth/top-bar.
 */
export function BrandLogo({ size = 160, className = "", alt = "Heritage Dahlias — est. 1932" }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      width={typeof size === "number" ? size : undefined}
      height={typeof size === "number" ? size : undefined}
      className={`select-none ${className}`}
      style={{
        width: px,
        height: px,
        objectFit: "contain",
        // Subtle drop so the sage emblem feels stamped on cream paper
        filter: "drop-shadow(0 6px 14px rgba(95,107,67,0.18))",
      }}
      draggable={false}
      data-testid="brand-logo"
    />
  );
}
